import { Popover } from "antd";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import axios from "axios";
import http from "@/utils/http";
import api from "@/utils/api";
import "./InsuranceVPH.scss";
import commonFn from "@/utils/commonFn";

const PolicyNumber = forwardRef(({ propRecord, v }, ref) => {
  const [activePopover, setActivePopover] = useState(null);
  const [descModalDeatail, setDescModalDeatail] = useState({});
  const detailRequestRef = useRef(null);

  const cancelDetailRequest = () => {
    detailRequestRef.current?.cancel();
    detailRequestRef.current = null;
  };

  useEffect(() => {
    return () => cancelDetailRequest();
  }, [propRecord?.propId, v?.number]);

  const getDescModalDeatailFn = async (v) => {
    cancelDetailRequest();
    const request = axios.CancelToken.source();
    detailRequestRef.current = request;

    try {
      const response = await http.get(api.ASInsurancePolicyDetail, {
        params: { propId: propRecord?.propId, customerAccount: v?.number },
        cancelToken: request.token,
      });
      if (request.token.reason || detailRequestRef.current !== request) {
        return;
      }
      if (response?.code !== "1") {
        commonFn.modalFailedFn(response);
        return;
      }
      setDescModalDeatail(response?.data || {});
    } catch (error) {
      if (!axios.isCancel(error) && detailRequestRef.current === request) {
        commonFn.modalFailedFn(error?.response?.data || error);
      }
    } finally {
      if (detailRequestRef.current === request) {
        detailRequestRef.current = null;
      }
    }
  };

  const DescModalDoc = () => {
    const {
      policyNumber,
      expirationDate,
      effectiveDate,
      carrier,
      agent,
      payee,
      deductible,
      limit,
    } = descModalDeatail;

    const IVPHMList = [
      { label: "Carrier", value: carrier },
      { label: "Agent", value: agent },
      { label: "Payee", value: payee },
      { label: "Deductible", value: deductible },
      { label: "Limit", value: limit },
    ];

    return (
      <div className="InsuranceVPHModal">
        <div className="IVPHMtitle">{policyNumber}</div>
        <div className="IVPHMtime">
          {expirationDate + " - " + effectiveDate}
        </div>
        <div className="IVPHMListBox">
          {IVPHMList.map((item) => (
            <div className="IVPHMList">
              <div className="IVPHMName">{item.label}</div>
              <div className="IVPHMValue">{item.value}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Popover
      content={DescModalDoc(v.number)}
      placement="left"
      trigger="click"
      open={activePopover === v}
      onOpenChange={(open) => {
        if (open) {
          setActivePopover(v);
          getDescModalDeatailFn(v);
        } else if (activePopover === v) {
          cancelDetailRequest();
          setActivePopover(null);
          setDescModalDeatail({});
        }
      }}
    >
      <span
        style={{
          color: "#1890ff",
          cursor: "pointer",
        }}
      >
        {v.number}
      </span>
    </Popover>
  );
});
export default PolicyNumber;
